var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"student-report-empty-state"},[_c('student-illustration',{staticClass:"w-full"}),_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"desc"},[_vm._v(_vm._s(_vm.desc))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }